import React from "react";
import "../../Styles/certified/inypeople.css";

export default function Inypeople() {
  return (
    <>
      <div className="certified-details-section">
        <div className="certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="certified-details-left">
            <img
              src="/New_Badge_TM.png"
              alt="Outstanding Workplaces Certified"
              className="certified-badge"
            />
            <div className="certified-company-names">
              <span className="certified-short-name">Inypeople</span>
              <h1 className="certified-full-name">
                Inypeople Technology Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="certified-details-right">
            <img
              src="/assets/inypeople/inypeople_building.png"
              alt="Inypeople Office"
              className="certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="certified-description">
          <h2>
            Why Inypeople Technology Private Limited is a Outstanding Workplaces
          </h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Praesent auctor purus luctus enim egestas, ac scelerisque ante pulvinar. Donec ut rhoncus ex. Suspendisse ac rhoncus nisl, eu tempor urna. Curabitur vel bibendum lorem. Morbi convallis convallis diam sit amet lacinia. Aliquam in elementum tellus.
          </p>
        </div>
        {/* Info Cards Section */}
        <div className="certified-info-cards">
          <div className="certified-info-card">
            <div className="certified-info-title">COMPANY SIZE</div>
            <div className="certified-info-value">10-50 Employees</div>
          </div>
          <div className="certified-info-card">
            <div className="certified-info-title">INDUSTRY</div>
            <div className="certified-info-value">Information Technology</div>
          </div>
          <div className="certified-info-card">
            <div className="certified-info-title">CONNECT</div>
            <div className="certified-info-icons">
              <span className="certified-icon-round">
                <a href="https://inypeople.com" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="certified-icon-round">
                <a href="https://linkedin.com/company/inypeople" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="certified-icon-round">
                <a href="https://facebook.com/inypeople" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
              <span className="certified-icon-round">
                <a href="https://instagram.com/inypeople" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/instagram.png" alt="Instagram" />
                </a>
              </span>
              <span className="certified-icon-round">
                <a href="https://x.com/inypeople" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/x.png" alt="X" />
                </a>
              </span>
            </div>
          </div>
          <div className="certified-info-card">
            <div className="certified-info-title">LOCATION</div>
            <div className="certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="certified-recognition-section">
        <h2 className="certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
        </h2>
        <div className="certified-recognition-badge">
            <img
            src="/New_Badge_TM.png" // or your badge image path
            alt="Outstanding Workplaces Certified"
            className="certified-recognition-image"
            />
        </div>
        <div className="certified-recognition-label">
            Outstanding Workplaces - Certified
        </div>
        </div>
        {/* Life at Inypeople Section */}
        <div className="certified-life-section">
        <h2 className="certified-life-title">
            Life at Inypeople Technology Private Limited
        </h2>
        <div className="certified-life-gallery">
            <div className="certified-life-col">
            <img src="/assets/inypeople/office1.png" alt="Office 1" className="certified-life-img" />
            <img src="/assets/inypeople/meeting1.png" alt="Meeting 1" className="certified-life-img" />
            </div>
            <div className="certified-life-col certified-life-center">
            <img src="/assets/inypeople/main.png" alt="Main Office" className="certified-life-img certified-life-img-large" />
            </div>
            <div className="certified-life-col">
            <img src="/assets/inypeople/office2.png" alt="Office 2" className="certified-life-img" />
            <img src="/assets/inypeople/meeting2.png" alt="Meeting 2" className="certified-life-img" />
            </div>
        </div>
        </div>
      </div>
    </>
  );
}